import { CaptionBase, LabelBase } from './styles';
import * as meta from '../../meta-data.json';

export const overrides = (props: any) => {
	return {
		Root: {
			props: {
				part: `epo-formcontrol-${meta.version}`,
				'data-epo': `epo-formcontrol-${meta.version}`,
			},
		},
		ControlContainer: {
			style: () => {
				return {
					position: props.isCaptionOverlay ? 'relative' : '',
				};
			},
		},
		Label: {
			style: ({ $disabled, $error, $positive }: any) => {
				return {
					...LabelBase($disabled, $error, $positive, props.size),
					marginBottom: '5px',
				};
			},
			props: {
				...props['label-props'],
			},
		},
		Caption: {
			style: ({ $disabled, $error, $positive }: any) => {
				return {
					...CaptionBase(
						$disabled,
						$error,
						$positive,
						props.size,
						props.warning,
						props.isCaptionOverlay,
						props.overlayCaptionMinWidth,
						props.overlayCaptionMaxWidth,
					),
					marginTop: props.isCaptionOverlay ? '0' : '5px',
				};
			},
			props: {
				...props['caption-props'],
			},
		},
	};
};
